import { type FC } from 'react';

import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityTwoToneIcon from '@mui/icons-material/VisibilityTwoTone';
import type { CheckboxRenderProps } from '../../viewOption/types.ts';

import { CheckboxRender } from './CheckboxRenderer.tsx';
import styled from 'styled-components';

export const EyeCheckboxRender: FC<CheckboxRenderProps> = (props) => {
  return (
    <CheckboxRender
      {...props}
      mixedComponent={<MixedComponent />}
      checkedComponent={<VisibilityOutlinedIcon />}
      uncheckedComponent={<VisibilityOffOutlinedIcon />}
    />
  );
};

const MixedComponent = styled(VisibilityTwoToneIcon)`
  color: ${({ theme }): string => theme.customPalette.panels.side.font};
`;
